import { BranchAddress } from "./branch-address";

export class GstBranchAddress extends BranchAddress {
}